module.exports = __webpack_public_path__ + "static/media/tj.a36b3491.svg";